import { render } from "./facilityLicenseModal.vue?vue&type=template&id=64123a67"
import script from "./facilityLicenseModal.vue?vue&type=script&lang=js"
export * from "./facilityLicenseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__